var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginState == 'PASSWORD'),expression:"loginState == 'PASSWORD'"}]},[_c('h2',{staticClass:"mb-3 text-2xl font-bold enter-x"},[_vm._v("登录")]),_c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleLogin}},[_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'username',
          {
            rules: [
              {
                required: true,
                message: '请输入账号',
              },
            ],
          },
        ]),expression:"[\n          'username',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请输入账号',\n              },\n            ],\n          },\n        ]"}],attrs:{"placeholder":"账号","size":"large"}})],1),_c('a-form-item',[_c('a-input-password',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'password',
          {
            rules: [
              {
                required: true,
                message: '请输入密码',
              },
            ],
          },
        ]),expression:"[\n          'password',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请输入密码',\n              },\n            ],\n          },\n        ]"}],attrs:{"placeholder":"密码","size":"large"}})],1),_c('a-form-item',[_c('PolicyModel')],1),_c('a-form-item',[_c('a-button',{attrs:{"type":"primary","block":"","size":"large","html-type":"submit","loading":_vm.login_loading}},[_vm._v("登录")])],1)],1),_c('div',{staticClass:"mr-4 mb-7 enter-x"},[_c('a',{staticClass:"float-left",on:{"click":function($event){return _vm.setLoginState('SMS_REGISTRY')}}},[_vm._v("注册")]),_c('a',{staticClass:"float-right",on:{"click":function($event){return _vm.setLoginState('SMS_LOGIN')}}},[_vm._v(" 验证码登入 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }